import { ReaderPlanItem } from "@modules/local/db";
import { SubscriptionCard } from "./SubscriptionCard";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import { setIsSubscriptionModalOpen } from "@lib/stores";
import { SVG } from "@components/items/common/SVG";
import TranslatedText from "@components/items/display/TranslatedText";

const SubscriptionHistoryTab = ({
  currentPlan,
}: {
  currentPlan: ReaderPlanItem | null;
}) => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-[60px] p-5">
      {currentPlan?.isFree ? (
        <SVG
          src="/assets/icons/free-subscription-card.svg"
          className="mt-10 h-[277px] w-[448px]"
        />
      ) : (
        <SubscriptionCard plan={currentPlan} />
      )}
      {currentPlan?.isFree && (
        <ShadcnButton
          className="rounded-lg px-[75px] py-7 text-[20px] text-white dark:bg-[#64A6E1] dark:hover:bg-[#64A6E1]"
          onClick={() => {
            setIsSubscriptionModalOpen(true);
          }}
        >
          <TranslatedText text="subscription.buttons.get-your-subscription" />
        </ShadcnButton>
      )}
    </div>
  );
};

export default SubscriptionHistoryTab;
